import React, { useContext, useEffect, useState } from "react";
import "./ProjectUserTable.css";
import { useLanguage } from "../../../../../LanguageProvider";
import { TbEdit } from "react-icons/tb";
import { HiOutlineUserRemove } from "react-icons/hi";
import UserEditModal from "./UserEditModal"; // Yeni modal bileşeni
import Services from "../../../../../services/Services";
import { GeneralContext } from "../../../../../GeneralProvider";
import AlertBox from "../../../../../components/AlertBox/AlertBox";
import UniversalTable from "../../../../../components/UniversalTable/UniversalTable";

export default function ProjectUserTable({ users, onPermissionChange }) {
    const {
        useToken,
        selectedProjectID,
        handleRemoveUserFromProject
    } = useContext(GeneralContext);
    const { getTranslation } = useLanguage();
    const [selectedUser, setSelectedUser] = useState(null);
    const [panels, setPanels] = useState([]);
    const [collections, setCollections] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [userModalOpen, setUserModalOpen] = useState(false);

    const handleEditClick = (user) => {
        setSelectedUser(user);
        setUserModalOpen(true)
    };

    const handleRemoveUserClick = (user) => {
        setIsAlertOpen(true)
        setSelectedUser(user);
    };

    const handleCloseModal = () => {
        setSelectedUser(null);
        setUserModalOpen(false)
    };

    useEffect(() => {
        fetchCollectionsAndPanels()
    }, [selectedProjectID]);

    const fetchCollectionsAndPanels = async () => {
        try {
            const response = await Services.GetCollectionAndPanelIDs(
                useToken,
                selectedProjectID
            );
            if (response.data.status) {
                setCollections(response.data.result.collections);
                setPanels(response.data.result.panels);
            } else {
                setCollections([]);
                setPanels([]);
            }
        } catch (error) {
            console.log(error);
            setCollections([]);
            setPanels([]);
        }
    };

    const handleConfirmRemoveUser = () => {
        setSelectedUser(null);
        setIsAlertOpen(false);
        handleRemoveUserFromProject(selectedUser.authID)
    };

    const handleCancelRemoveUser = () => {
        setIsAlertOpen(false);
    };

    const columns = [
        {
            key: 'userNameLastname',
            header: `${getTranslation('name')} ${getTranslation('lastname')}`
        },
        {
            key: 'email',
            header: getTranslation('email')
        },
        {
            key: 'actions',
            header: '',
            render: (row) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                    <button className="user-edit-button" onClick={() => handleEditClick(row)}>
                        <TbEdit strokeWidth={1} size={20} />
                        {getTranslation('edit')}
                    </button>
                    <button className="user-edit-button" onClick={() => handleRemoveUserClick(row)}>
                        <HiOutlineUserRemove strokeWidth={1} size={20} />
                        {getTranslation('removeUser')}
                    </button>
                </div>
            )
        }
    ];

    return (
        <div className="user-table-container">
            <UniversalTable
                data={users || []}
                columns={columns}
                containerClassName="user-table-container"
                tableClassName="user-table"
                emptyText={getTranslation('noData')}
            />

            {/* Modal Bileşeni */}
            {selectedUser && userModalOpen && (
                <UserEditModal user={selectedUser} collections={collections} panels={panels} onClose={handleCloseModal} />
            )}


            <AlertBox
                isOpen={isAlertOpen}
                title={getTranslation("areYouSure")}
                message={getTranslation("removeUserConfirmation")}
                onConfirm={handleConfirmRemoveUser}
                onCancel={handleCancelRemoveUser}
                confirmText={getTranslation("yes")}
                cancelText={getTranslation("no")}
                type={"warning"}
            />
        </div>
    );
}
